<template>
    <v-container fluid grid-list-lg class="mx-0 mt-5 pa-0">
        <v-card flat color="#354d61" class="white--text" align="center" href="http://newish.gofiqr.com/jrcI5Q" target="_blank">
            <v-layout align-center justify-center>
                <v-flex xs3 offset-xs-1>
                    <v-img :src="require('@/assets/jrcI5Q.png')" height="111" width="111" max-height="300" max-width="300" class="ma-2"/>
                </v-flex>
                <v-flex xs8>
                    <v-card-title primary-title align="left" class="try-text display-1">
                        Prøv gofiqr.<br>
                        Scan koden eller klik HER.
                    </v-card-title>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</template>
<script>
    export default {
        name: 'TryGofiqr'
    }
</script>
<style scoped>
</style>
